import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFilteredCountries } from '../../../../../redux/actions/countries'
import { getLanguages } from '../../../../../redux/actions/languages'
import { getRoles } from '../../../../../redux/actions/roles'
import { IRootState } from '../../../../../redux/types'

function useInitialState() {
  const dispatch = useDispatch()
  const isInitialized = useRef(false)
  const { languages } = useSelector((state: IRootState) => state.language)
  const { roles } = useSelector((state: IRootState) => state.role)
  const { countries } = useSelector((state: IRootState) => state.country)

  useEffect(() => {
    if (isInitialized.current) return
    isInitialized.current = true

    if (roles.length === 0) dispatch(getRoles())
    if (languages.length === 0) dispatch(getLanguages())
    if (countries.length === 0) dispatch(getFilteredCountries())
  }, [dispatch, languages.length, roles.length, countries.length])
}

export default useInitialState
